import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ClearIconMLStyled from './ClearIconMLStyled';

const ClearIconML = (props) => {
  return (
    <ClearIconMLStyled right={props.right} bottom={props.bottom}>
      {(props.clearValue ||
        props.clearValue === 0 ||
        props.clearValue === '0') && (
        <IconButton
          className="clear-btn-wrap"
          onClick={props.handleClick}
          disabled={props.disabled}
        >
          <ClearIcon className="clear-icon" />
        </IconButton>
      )}
    </ClearIconMLStyled>
  );
};

export default ClearIconML;
